import { basicApi } from "@/http/clients/modules/basicApi";
import { map } from "@/http/clients/modules/map";
import { userPreference } from "@/http/clients/modules/userPreference";
import { noAuthApi } from "@/http/clients/modules/noAuthApi";
import {
  loginClient,
  logoutClient,
  touchClient,
} from "@/http/clients/modules/auth";
import { firmwareUpgrade } from "@/http/clients/modules/firmwareUpgrade";
import { manager } from "@/http/clients/manager";

export const clients = {
  basicApi,
  loginClient,
  logoutClient,
  touchClient,
  map,
  userPreference,
  noAuthApi,
  firmwareUpgrade,
};

export { manager };
